import React from 'react';
import { Button } from 'devextreme-react/button';

import HXUserFilters from '../../../custom-components/hx-user-filters/HXUserFilters'
import ShuttlesAdminLocationsDataGrid from './sub-components/ShuttlesAdminLocationsDataGrid'
import HxPopupExportExcel from '../../../custom-components/hx-popup-excel-export/HxPopupExportExcel';
import PopupShuttlesAdminLocationsUserSettings from './sub-components/PopupShuttlesAdminLocationsUserSettings'

import './ShuttlesAdminLocations.scss';


class ShuttlesAdminLocations extends React.Component {
    constructor(props) {
        super(props);

        this.popupExportExcelInstance = null;
        this.popupShuttlesAdminLocationsUserSettingsInstance = null;

        // filters
        this.loadedUserFilterValue = [];
    }

    popupExportExcel_OnInitialized = (instance) => {
        this.popupExportExcelInstance = instance;
    }

    popupExportExcel_OnSave = async (fileName) => {
        if (fileName) {
            await this.refDataGrid.exportToExcel(fileName);
        }
    }

    popupShuttlesAdminLocationsUserSettings_OnInitialized = (instance) => {
        this.popupShuttlesAdminLocationsUserSettingsInstance = instance;
    }

    popupShuttlesAdminLocationsUserSettings_OnUpdate = (elementId, value) => {
        this.refDataGrid.applyUserSettings(elementId, value)
    }

    exportLocations = async () => {
        this.popupExportExcelInstance.show();
    }

    buttonUserSettings_OnClick = (e) => {
        this.popupShuttlesAdminLocationsUserSettingsInstance.show();
    }

    // GRID
    grid_OnInitialized = (instance) => {
        this.dataGridInstance = instance;
        this.refUserFilters.setDataGridInstance(instance);
    }

    // USERFILTER
    userFilterLoaded = async (filterState) => {
        // display loadpanel
        this.dataGridInstance.beginCustomLoading("Loading...");

        this.dataGridInstance.beginUpdate();

        if (filterState.filterValue !== undefined) {
            this.dataGridInstance.option('filterValue', JSON.parse(filterState.filterValue));
            this.loadedUserFilterValue = this.dataGridInstance.option('filterValue');
        } else {
            this.loadedUserFilterValue = [];
        }

        this.dataGridInstance.endUpdate();

        // hide loadpanel
        this.dataGridInstance.endCustomLoading();
    }

    clearUserFilter = () => {
        this.dataGridInstance.clearFilter();
    }

    userFilterError = (error) => {
        //this.setErrorHeader(error);
    }

    render() {
        return (
            <React.Fragment>
                <div className='shuttles-admin-locations-main-div'>
                    <div className='shuttles-admin-locations-content-block'>
                        <div id='toolBarLocations' className='hx-toolbar-main-div'>
                            <div className='hx-toolbar-left'>
                                <span>
                                    <Button
                                        icon="xlsxfile"
                                        stylingMode='outlined'
                                        text="Locations"
                                        onClick={this.exportLocations} />
                                </span>
                            </div>
                            <div className='hx-toolbar-right'>
                                <span>
                                    <HXUserFilters
                                        ref={ref => (this.refUserFilters = ref)}
                                        onUserFilterLoaded={this.userFilterLoaded}
                                        onClearFilter={this.clearUserFilter}
                                        onError={this.userFilterError}
                                        filterTypeName='locations'
                                    />
                                </span>
                                <span>
                                    <Button
                                        icon='preferences'
                                        stylingMode='text'
                                        text=''
                                        onClick={this.buttonUserSettings_OnClick}
                                    />
                                </span>
                            </div>
                        </div>
                        <div className='shuttles-admin-locations-grid-card'>
                            <ShuttlesAdminLocationsDataGrid
                                ref={ref => this.refDataGrid = ref}
                                onInitialized={this.grid_OnInitialized}
                            />
                        </div>
                    </div>
                </div>

                <HxPopupExportExcel
                    defaultName='Locations'
                    onInitialized={this.popupExportExcel_OnInitialized}
                    onSave={this.popupExportExcel_OnSave}
                />

                <PopupShuttlesAdminLocationsUserSettings
                    onInitialized={this.popupShuttlesAdminLocationsUserSettings_OnInitialized}
                    onUpdate={this.popupShuttlesAdminLocationsUserSettings_OnUpdate}
                />
            </React.Fragment>
        );
    }
}

export default ShuttlesAdminLocations
